<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div class="view">
        <h2>Administration</h2>

        <b-col cols="10">
            <b-row class="mt-4">
                <b-col>
                    <b-button type="button" variant="success" @click="exportPeriodique">Exporter la base de données (format Cockpit)
                    </b-button>
                </b-col>
            </b-row>
            <b-row class="mt-4">
                <b-col>
                    <b-button type="button" variant="success" @click="exportLogs">Exporter les fichiers de logs applicatifs
                    </b-button>
                </b-col>
            </b-row>
        </b-col>
    </div>
</template>

<script>

  import AdministrationStore from "../../stores/AdministrationStore";
  import AlertStore from "../../stores/AlertStore";
  import FileUtil from "../../utils/fileUtil";

  export default {
    methods: {
      exportPeriodique() {
        AdministrationStore.exportPeriodique().then(
            result => {
              FileUtil.downloadFile(result.data, 'application/zip');
            },
            error => AlertStore.pushError(error.response.data.message)
        );
      },
      exportLogs() {
        AdministrationStore.exportLogs().then(
            result => {
              FileUtil.downloadFile(result.data, 'application/zip');
            },
            error => AlertStore.pushError(error.response.data.message)
        );
      }
    }
  }
</script>

